module.exports = __webpack_public_path__ + "img/IOI_white_large.65ae0c0e.png";